<bizz-status-icon [statusType]="value!"></bizz-status-icon>